/**
 *
 * Audiences
 *
 */

import React, { useState, useEffect, useCallback, useMemo } from "react";
import classNames from "classnames";
import { useLocation, useParams } from "react-router-dom";

// styles
import "./style.scss";

// antd component
import { Button, Dropdown, Menu, Input } from "antd";

// assets
import { DownOutlined } from "@ant-design/icons";
// import CustomIcons from 'components/CustomIcons';
import { useTranslation } from "react-i18next";

// components
import ErrorBoundary from "engine/ErrorBoundary";
import CustomPageHeader from "components/CustomPageHeader";
import GoBackButton from "components/GoBackButton";

// helper for forms
import { parseQuery } from "utils/history";

function AudienceHeader({
  // main
  currentElement,
  // states
  loadingUpdate,
  loadingDelete,
  // actions
  onSave,
  onDelete,
  onAddNewMember,
  updateElement,
  onGoBack,
  //default
  className,
}) {
  const { t, i18n } = useTranslation();
  const childClassNames = classNames("audiences-header-wrapper", className);
  const newKey = "new";
  const location = useLocation();
  const { id: initId } = useParams();

  const [name, setCurrenName] = useState(currentElement?.title || "");

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    return () => {
      // Anything in here is fired on component unmount.
      // Clearing the state after unmounting a component
    };
  }, []);

  const actionDropdownCallback = useCallback(
    async actionKey => {
      switch (actionKey.key) {
        case "student":
        case "teacher":
        case "admin":
          onAddNewMember(actionKey.key);
          break;

        case "delete":
          if (initId && initId !== newKey) {
            !!onDelete && onDelete(initId);
          } else if (initId == newKey) {
            !!updateElement && updateElement(false);
          }
          break;
      }
    },
    [initId, location.search, currentElement],
  );

  const actionsMenu = useMemo(() => {
    const menuItems = [
      {
        key: "student",
        icon: null,
        label: t("audiences.addStudent"),
        disabled: false,
      },
      {
        key: "teacher",
        icon: null,
        label: t("audiences.addTeacher"),
        disabled: false,
      },
      {
        key: "admin",
        icon: null,
        label: t("audiences.addAdministration"),
        disabled: false,
      },
      {
        key: "delete",
        icon: null,
        label: t("audiences.deleteAudience"),
        disabled: loadingUpdate || loadingDelete,
        danger: true,
      },
    ];
    return (
      <Menu onClick={actionDropdownCallback} items={menuItems} />
      /*         <Menu.Item key="student">Ajouter un étudiant</Menu.Item>
        <Menu.Item key="teacher">Ajouter un enseignant</Menu.Item>
        <Menu.Item key="admin">Ajouter un administrateur</Menu.Item>
        <Menu.Item
          key="delete"
          disabled={loadingUpdate || loadingDelete}
          danger
        >
          Supprimer l’audience
        </Menu.Item>
      </Menu> */
    );
  }, [actionDropdownCallback, loadingUpdate, loadingDelete, i18n?.language]);

  const onChangeName = useCallback(
    e => {
      const value = e?.target?.value;
      setCurrenName(value);
      !!updateElement && updateElement({ ...currentElement, title: value });
    },
    [updateElement, currentElement],
  );

  const NameFiled = useMemo(
    () => (
      <div className="audience-title-wrapper">
        <span className="label">{t("audiences.nameOfAudience")}</span>
        <Input
          value={name || currentElement?.title}
          placeholder={t("audiences.nameOfAudience")}
          disabled={loadingUpdate || loadingDelete}
          onChange={onChangeName}
        />
      </div>
    ),
    [name, currentElement?.title, loadingUpdate, loadingDelete, i18n?.language],
  );

  // render function
  return (
    <div className={childClassNames}>
      <ErrorBoundary>
        {!!onGoBack && <GoBackButton onGoBack={onGoBack} />}

        <CustomPageHeader
          className="audiences-header"
          title={currentElement?.title || t("audiences.newAudience")}
          subTitle={t("audiences.subTitle")}
          subTitlePosition="top"
          extraActions={[
            <Dropdown
              className="audiences-actions"
              trigger={["click"]}
              overlay={actionsMenu}
              getPopupContainer={trigger => trigger.parentElement}
              overlayClassName="communication-actions__menu"
            >
              <Button>
                <span className="dropdownLabel">
                  {t("common.actions")}
                </span>
                <DownOutlined />
              </Button>
            </Dropdown>,
            !!onSave && (
              <Button
                className="ant-btn-submit audience-submit"
                type="default"
                onClick={onSave}
              >
                {t("common.save")}
              </Button>
            ),
          ]}
        />
        {NameFiled}
      </ErrorBoundary>
    </div>
  );
}

AudienceHeader.propTypes = {};

export default AudienceHeader;
